'use strict';

var addMonths = require('date-fns/addMonths');
var startOfDay = require('date-fns/startOfDay');
var React = require('react');
var reactUtils = require('@sravni/react-utils');
var Calendar_module = require('../styles/Calendar.module.less.js');
var Header = require('./Header.js');
var Month = require('./Month.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

function isDateRange(value) {
    return !!value && 'from' in value && 'to' in value && value.from instanceof Date && value.to instanceof Date;
}
/**
 * @description Calendar component.
 *
 * @component
 * @example
 * ```jsx
 * <Calendar />
 * ```
 */
const Calendar = React__namespace.forwardRef((props, ref) => {
    const { minDate, maxDate, rangeLimit, disabledIntervals, mode = 'single', selection, defaultDate = minDate !== undefined ? minDate : new Date(), className, onChange, ...restProps } = props;
    const [activeMonth, setActiveMonth] = React__namespace.useState(() => {
        if (isDateRange(selection)) {
            return selection.from;
        }
        if (selection)
            return selection;
        return defaultDate;
    });
    const [selectionStart, setSelectionStart] = React__namespace.useState(selection && startOfDay.startOfDay(isDateRange(selection) ? selection.from : selection));
    const [selectionEnd, setSelectionEnd] = React__namespace.useState(selection && startOfDay.startOfDay(isDateRange(selection) ? selection.to : selection));
    const [selectionInProgress, setSelectionInProgress] = reactUtils.useBoolean(false);
    const cx = reactUtils.useStyles(Calendar_module.default);
    const classNames = cx(className, 'container');
    const normalizedMinDate = minDate ? startOfDay.startOfDay(minDate) : minDate;
    const handleChangeMonth = React__namespace.useCallback((direction) => {
        switch (direction) {
            case 'prev':
                return setActiveMonth(addMonths.addMonths(activeMonth, -1));
            case 'next':
            default:
                return setActiveMonth(addMonths.addMonths(activeMonth, 1));
        }
    }, [activeMonth]);
    const handleChangeSelected = React__namespace.useCallback((range) => {
        setSelectionStart(range.from);
        setSelectionEnd(range.to);
        if (mode === 'range') {
            selectionInProgress && onChange?.(range);
            setSelectionInProgress.toggle();
        }
        else {
            onChange?.(range.from);
            setSelectionInProgress.off();
        }
    }, [selectionInProgress, mode, setSelectionInProgress, onChange]);
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Calendar", className: classNames, ...restProps },
        React__namespace.createElement(Header.Header, { month: activeMonth, onChange: handleChangeMonth }),
        React__namespace.createElement(Month.Month, { month: activeMonth, minDate: normalizedMinDate, maxDate: maxDate, rangeLimit: rangeLimit, disabledIntervals: disabledIntervals, mode: mode, selectionStart: selectionStart, selectionEnd: selectionEnd, selectionInProgress: selectionInProgress, onChange: handleChangeSelected })));
});
Calendar.defaultProps = {
    mode: 'single',
};
Calendar.displayName = 'Calendar';

exports.Calendar = Calendar;
//# sourceMappingURL=Calendar.js.map
